import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import throttle from 'lodash.throttle';
import { toggleLoginBox } from 'components/Login/redux';
import { loadAjaxSectionData } from 'routes/newslisting/redux';
import { loadGeoLocationData } from 'reduxUtils/modules/geo';
import { setPageConfigAndSendIBeatCall } from 'utils/iBeatConfig';
import makeRequest from 'utils/makeRequest';
import Cookie from 'utils/cookies';
import Link from 'components/Link';
import BreadCrumb from 'components_v2/common/BreadCrumb/BreadCrumb';
import TrendingSlider from 'components_v2/desktop/TrendingSlider/TrendingSlider';
import { UseIntersectionObeserver } from 'routes/home/layouts/India/context';
import { inViewForReact, postCreditScoreMessage } from 'utils/common';
import { getExperimentRefresh } from 'utils/experimentUtils';
import { gaWrapper } from 'helpers/analytics';
// import FuelCoronaWidget from '../../components/common/FuelCoronaWidget';
import s from './NewsListing.scss';
import RenderComponent from './RenderComponent';
import { RenderRhsData } from './photolist/RenderComponent';

class NewsListing extends React.Component {
  constructor() {
    super();
    this.state = {
      // showLiveInsert: true,
    };
    this.postMessageFired = false;
  }

  setLanguageValInContext = (geoCity, setInCookie) => {
    if (!geoCity) {
      return;
    }
    makeRequest
      .get(
        `https://ematrix.filmipop.com/v2/city/get?city_name=${geoCity}`,
        {},
        'skipfeedengine',
      )
      .then(data => {
        if (data && data.data && data.data.primary_language) {
          if (setInCookie) {
            let domain = 'indiatimes.com';
            if (document.domain.indexOf('timesofindia.com') >= 0) {
              domain = 'timesofindia.com';
            }
            Cookie.set('geolocation', geoCity, 365, '/', domain);
            Cookie.set('geostate', data.data.state_code, 365, '/', domain);
            if (typeof this.props.loadGeoLocationData === 'function') {
              this.props.loadGeoLocationData();
            }
          }
        }
      });
  };

  scrollToHashElementsSmoothly = () => {
    // eslint-disable-next-line prefer-destructuring
    const hash = window.location.hash;
    if (hash) {
      const id = hash.replace('#', '');
      const element = document.getElementById(id);
      if (element) {
        setTimeout(() => {
          const yOffset = -100;
          const y =
            element.getBoundingClientRect().top + window.pageYOffset + yOffset;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }, 0);
      }
    }
  };

  componentDidMount() {
    // try {
    //   gaWrapper(
    //     'send',
    //     'event',
    //     this.props.gaCategory,
    //     'landing',
    //     window?.location?.href,
    //     {
    //       nonInteraction: 1,
    //     },
    //   );
    // } catch (error) {
    //   // unhandled error
    // }
    getExperimentRefresh(this.props.refreshTime);
    this.setScrollGAElements();
    this.throttledonScroll = throttle(this.handleOnScroll, 100);
    window.addEventListener('scroll', this.throttledonScroll);
    setPageConfigAndSendIBeatCall();
    const { location } = this.props;
    if (location && location === '/business/financial-literacy') {
      this.scrollToHashElementsSmoothly();
    }
  }

  componentDidUpdate(prevProps) {
    const { userData } = this.props;

    if (typeof document !== 'undefined') {
      const iframe = document.getElementById('creditscoreiframe');
      if (
        !this.postMessageFired &&
        iframe &&
        (!prevProps.userData ||
          (typeof prevProps.userData === 'object' &&
            !('isLoggedIn' in prevProps.userData))) &&
        typeof userData === 'object' &&
        'isLoggedIn' in userData
      ) {
        postCreditScoreMessage(userData);
        this.postMessageFired = true;
      }
    }
  }

  setScrollGAElements() {
    try {
      this.scrollGAElements = [
        ...document.querySelectorAll('[data-scrollga]:not([data-scrollga=""])'),
      ];
    } catch (e) {
      // console.log(e);
    }
  }

  handleOnScroll = () => {
    const prevTop = 0;
    let currentTop = 0;
    const doc = document.documentElement;
    currentTop = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0);

    if (currentTop > prevTop) {
      for (let i = 0; i < this.scrollGAElements.length; i += 1) {
        if (
          this.scrollGAElements[i] &&
          inViewForReact(this.scrollGAElements[i], 0, true)
        ) {
          let gaData =
            this.scrollGAElements[i].getAttribute('data-scrollga') || '';
          gaData = gaData.split('#');
          const action = gaData[0] || '';
          const label = gaData[1] || window?.location?.href;
          gaWrapper('send', 'event', this.props.gaCategory, action, label, {
            nonInteraction: 1,
          });
          this.scrollGAElements[i].removeAttribute('data-scrollga');
          this.scrollGAElements.splice(i, 1);
        }
      }
    }
  };

  renderRhsComponent = rhsData => {
    const { isPrime } = this.props;
    if (Array.isArray(rhsData)) {
      const rdata = isPrime ? rhsData.filter(v => v && v.tn !== 'ad') : rhsData;
      if (Array.isArray(rdata) && rdata.length) {
        return rdata.map(data => RenderRhsData(data, data.tn));
      }
    }
    return null;
  };

  renderPageWithRHSComponents = (
    topComponent,
    renderPageComponent,
    rhsData,
  ) => {
    const renderRhsComponent = this.renderRhsComponent(rhsData);
    return (
      <>
        {topComponent}
        <div className={s.photolistBody}>
          <div className={s.lhs}>{renderPageComponent}</div>
          <div className={`${s.leftColSpacing}`}>
            <div className={s.rhsstickybox}>{renderRhsComponent}</div>
          </div>
        </div>
      </>
    );
  };

  // Render Component Fucntion
  renderPageComponents = (
    sectionItem,
    isloggedIn,
    subSection,
    details,
    cardsInserts,
    showToiPlusEntryPoints,
    isPrime,
    location,
    sectionName,
  ) =>
    sectionItem.map((data, index) =>
      RenderComponent(
        data,
        data.tn,
        isloggedIn,
        subSection,
        this.props.toggleLoginBox,
        cardsInserts,
        index,
        showToiPlusEntryPoints,
        isPrime,
        this.props.loadAjaxSectionData,
        location,
        this.props.newsData.seo,
        sectionName,
        this.props.isPaginationEnabled,
        this.props.isInPageDock,
        this.props.BudgetoMeterData,
        this.props.newsData,
      ),
    );
  // Render Component Fucntion

  render() {
    const {
      newsData: { sectionitems, details, rhsData = null },
      userData,
      subSection,
      cardsInserts,
      gaCategory,
      location,
      newsData = {},
      isBoardResultPage,
      boardResultMsid,
    } = this.props;
    const fullWidthComponentOffset =
      details && details.fullWidthComponentOffset
        ? details.fullWidthComponentOffset
        : 0;
    const hasRHSData = !!(rhsData && rhsData.length);
    let breadCrumbData =
      this.props.navigation && this.props.navigation.breadcrumbs
        ? this.props.navigation.breadcrumbs
        : [];

    if (
      isBoardResultPage &&
      boardResultMsid &&
      (boardResultMsid === '109374548' || boardResultMsid === '109374567') &&
      Array.isArray(breadCrumbData) &&
      breadCrumbData.length > 0
    ) {
      breadCrumbData = [
        ...breadCrumbData,
        {
          label: `MP Board ${
            boardResultMsid === '109374548' ? '10th' : '12th'
          } Result`,
        },
      ];
    } else if (
      isBoardResultPage &&
      boardResultMsid &&
      (boardResultMsid === '109398428' || boardResultMsid === '109398401') &&
      Array.isArray(breadCrumbData) &&
      breadCrumbData.length > 0
    ) {
      breadCrumbData = [
        ...breadCrumbData,
        {
          label: `WB Board ${
            boardResultMsid === '109398428' ? '12th' : '10th'
          } Result`,
        },
      ];
    } else if (
      isBoardResultPage &&
      boardResultMsid &&
      (boardResultMsid === '109063180' || boardResultMsid === '109063206') &&
      Array.isArray(breadCrumbData) &&
      breadCrumbData.length > 0
    ) {
      breadCrumbData = [
        ...breadCrumbData,
        {
          label: `RBSE Board ${
            boardResultMsid === '109063180' ? '10th' : '12th'
          } Result`,
        },
      ];
    }
    let isloggedIn;
    const sectionName = `${
      subSection.subsections ? subSection.subsections : ''
    }`;

    if (userData && typeof userData === 'object') {
      isloggedIn = userData.isLoggedIn;
    }

    if (
      !isBoardResultPage &&
      !sectionitems &&
      typeof sectionitems !== 'object'
    ) {
      return null;
    }

    let renderPageComponent = null;

    if (this.props.isBoardResultPage) {
      renderPageComponent = RenderComponent(
        {
          ...newsData,
          adCode:
            '/7176/TOI/TOI_Home/TOI_Home_Education_AL/TOI_ROS_ATF_HOM_EDU_AL_300',
        },
        'board_form', //data.tn,
        isloggedIn,
        subSection,
        this.props.toggleLoginBox,
        cardsInserts,
        0,
        this.props.showToiPlusEntryPoints,
        this.props.isPrime,
        this.props.loadAjaxSectionData,
        location,
        this.props.newsData.seo,
        sectionName,
        this.props.isPaginationEnabled,
        this.props.isInPageDock,
        this.props.BudgetoMeterData,
      );
    } else {
      renderPageComponent = hasRHSData
        ? null
        : this.renderPageComponents(
            sectionitems,
            isloggedIn,
            gaCategory,
            details,
            cardsInserts,
            this.props.showToiPlusEntryPoints,
            this.props.isPrime,
            this.props.location,
            sectionName,
          );
    }

    const renderPageWithRHS = hasRHSData
      ? this.renderPageWithRHSComponents(
          this.renderPageComponents(
            sectionitems.slice(0, fullWidthComponentOffset),
            isloggedIn,
            gaCategory,
            details,
            cardsInserts,
            this.props.showToiPlusEntryPoints,
            this.props.isPrime,
            this.props.location,
            sectionName,
          ),
          this.renderPageComponents(
            sectionitems.slice(fullWidthComponentOffset),
            isloggedIn,
            gaCategory,
            details,
            cardsInserts,
            this.props.showToiPlusEntryPoints,
            this.props.isPrime,
            this.props.location,
            sectionName,
          ),
          rhsData,
        )
      : null;

    // let FuelPollutionData;
    // if (
    //   typeof details.inserts !== 'undefined' &&
    //   typeof details.inserts.items !== 'undefined' &&
    //   Array.isArray(details.inserts.items)
    // ) {
    //   FuelPollutionData = details.inserts.items[0];
    // } else if (
    //   typeof details.inserts !== 'undefined' &&
    //   typeof details.inserts.tn !== 'undefined' &&
    //   details.inserts.tn === 'IndexesTracker'
    // ) {
    //   FuelPollutionData = details.inserts;
    // }
    const pageBasedWrapperClass =
      details && details.wrapperClass ? details.wrapperClass : '';
    const powerbyClass =
      details && details.powerbyClass ? details.powerbyClass : '';
    const sponsoredTxt =
      details && details.sponsoredTxt ? details.sponsoredTxt : '';
    const sponseredLogo =
      details && details.sponsoredLogomsid ? details.sponsoredLogomsid : '';
    const sponsoredLink =
      details && details.sponsoredLink ? details.sponsoredLink : '';
    const sponsoredClass =
      details && details.sponsoredClass ? details.sponsoredClass : '';
    const alignClass = details && details.alignClass ? details.alignClass : '';

    const hideLabel = details && details.hideLabel ? details.hideLabel : '';

    const brandLogo = details && details.logo ? details.logo : '';

    const hideTitle =
      (details &&
        details.h1 &&
        (details.h1 === 'budget survey News' ||
          details.h1 === 'Cricket Match Center' ||
          details.h1 === 'Modi Meter' ||
          details.h1 === 'Empty' ||
          details.h1 === 'Astrology' ||
          details.h1 === 'Horoscope' ||
          details.h1.indexOf('calculator') > -1 ||
          details.h1.indexOf('bihar-board-bseb-class-') > -1 ||
          details.h1.indexOf('Child T20 Stats Page') > -1)) ||
      this.props.isBoardResultPage;
    const topSearches = _get(this.props, 'commonData.topSearches');
    // console.log('details', details);
    return (
      <UseIntersectionObeserver.Provider value>
        <div className="popupWrapper" />
        <div
          className={`${s.newsListingWrapper} ${pageBasedWrapperClass}`}
          data-translate-id="cw"
          data-translate-page="1"
        >
          <BreadCrumb data={breadCrumbData} wrapperClass="breadcrumb" />
          {topSearches &&
            Array.isArray(topSearches.items) &&
            topSearches.items.length > 0 && (
              <div
                className={this.props.isCityHP ? s.trending_wrapper_main : ''}
              >
                <TrendingSlider
                  topSearches={topSearches.items}
                  title={topSearches?.name}
                />
              </div>
            )}
          <div>
            {sponsoredClass !== 'budgetyousponsored' &&
              sponseredLogo && (
                <div
                  className={`${s.logoAd} ${sponsoredClass}  ${
                    alignClass ? s.leftAlign : ''
                  }`}
                >
                  <div className={s.adLogoText}>{sponsoredTxt}</div>
                  {sponsoredLink ? (
                    <Link to={sponsoredLink} doNotChangeURL target="_blank">
                      <img
                        src={`https://static.toiimg.com/photo/msid-${sponseredLogo}.cms`}
                        alt={sponsoredTxt}
                      />
                    </Link>
                  ) : (
                    <img
                      src={`https://static.toiimg.com/photo/msid-${sponseredLogo}.cms`}
                      alt={sponsoredTxt}
                    />
                  )}
                </div>
              )}
          </div>
          <div
            className={`${s.heading_fuelWidget} ${s[powerbyClass]} ${
              sectionName === 'cricket' ? 'sports_title_fix' : ''
            } ${
              // sectionName === 'business' ? s['financialCard'] : ''
              s[pageBasedWrapperClass]
            }`}
          >
            {!hideTitle &&
              (!hideLabel ? (
                <h1 className={s.h1tag}>
                  {details.h1
                    ? details.h1.replace(/-/g, ' ')
                    : sectionName.replace(/-/g, ' ')}
                </h1>
              ) : (
                // eslint-disable-next-line jsx-a11y/heading-has-content
                <h1 className={s.h1tag}>
                  {brandLogo && (
                    <img
                      src={`https://static.toiimg.com/photo/msid-${brandLogo}.cms`}
                      height="25"
                      alt={details.h1}
                    />
                  )}
                </h1>
              ))}

            {/* Due to the budget prioroity task we have added this. Once it's done, will remove it. */}
            {/* {!isPrime &&
              subsec2 === 'budget-takeaway' && (
                <AdCaller
                  immediateLoad
                  data={{
                    adCode: '/7176/TOI/TOI_Budget/TOI_Bgt_PoweredBy2_80x16',
                    size: [146, 44],
                    divId: 'div-gpt-ad-13413435696123-0',
                  }}
                />
              )}
            {powerbyClass &&
              powerbyTxt && (
                <img
                  src="https://m.timesofindia.com/photo/85398519.cms"
                  alt={powerbyTxt}
                />
              )} */}
            {sponsoredClass === 'budgetyousponsored' &&
              sponseredLogo && (
                <div
                  className={`${s.logoAd} ${sponsoredClass} ${
                    s.budgetyousponsored
                  } ${alignClass ? s.leftAlign : ''}`}
                >
                  {/* <div className={s.adLogoText}>{sponsoredTxt}</div> */}
                  {sponsoredLink ? (
                    <Link to={sponsoredLink} doNotChangeURL target="_blank">
                      <img
                        src={`https://static.toiimg.com/photo/msid-${sponseredLogo}.cms`}
                        height="40"
                        alt="Sponsored by"
                      />
                    </Link>
                  ) : (
                    <img
                      src={`https://static.toiimg.com/photo/msid-${sponseredLogo}.cms`}
                      height="40"
                      alt="Sponsored by"
                    />
                  )}
                </div>
              )}
            {/* {FuelPollutionData !== null &&
              typeof FuelPollutionData === 'object' && (
                <FuelCoronaWidget
                  data={FuelPollutionData}
                  geoCityData={this.props.geoCityData}
                  isWapView
                  callBack={this.setLanguageValInContext}
                />
              )} */}
            {/* {IndexesTrackerData && <IndexesTracker data={IndexesTrackerData} />} */}
          </div>
          {hasRHSData ? renderPageWithRHS : renderPageComponent}
        </div>
      </UseIntersectionObeserver.Provider>
    );
  }
}
const mapDispatchtoProps = dispatch => ({
  loadAjaxSectionData: params => {
    dispatch(loadAjaxSectionData(params));
  },
  toggleLoginBox: params => {
    dispatch(toggleLoginBox(params));
  },
  loadGeoLocationData: params => {
    dispatch(loadGeoLocationData(params));
  },
});

const mapStateToProps = state => ({
  newsData: state.newslisting && state.newslisting.data,
  BudgetoMeterData: state.newslisting && state.newslisting.budgetoMeter,
  navigation: state.header.data && state.header.data.navigation,
  isPrime: state.isPrime,
  userData: _get(state, 'login.userData', {}),
  geoCityData: state.geo.cityData,
  showToiPlusEntryPoints: _get(
    state,
    'toiplusconfig.showToiPlusEntryPoints',
    false,
  ),
  commonData: state.commonData && state.commonData.data,
  isPaginationEnabled: _get(
    state,
    'common.siteConfig.isPaginationEnabled',
    undefined,
  ),
});

NewsListing.propTypes = {
  newsData: PropTypes.objectOf({}),
  navigation: PropTypes.shape({
    breadcrumbs: '',
  }),
  userData: PropTypes.shape({
    isLoggedIn: '',
  }),
  subSection: PropTypes.shape({
    subsections: '',
  }),
  seoData: PropTypes.shape({
    title: '',
    canonical: '',
  }),
  geoCityData: PropTypes.shape({
    city: PropTypes.string,
  }),
  toggleLoginBox: PropTypes.func,
  cardsInserts: PropTypes.objectOf({}),
  gaCategory: PropTypes.string,
  showToiPlusEntryPoints: PropTypes.bool,
  isPrime: PropTypes.bool,
  location: PropTypes.string,
  refreshTime: PropTypes.number,
  isCityHP: PropTypes.bool,
  isPaginationEnabled: PropTypes.bool,
  BudgetoMeterData: PropTypes.objectOf({}),
};
NewsListing.defaultProps = {
  newsData: {},
  navigation: {},
  seoData: {},
  subSection: {},
  userData: {},
  toggleLoginBox: () => {},
  cardsInserts: {},
  gaCategory: '',
  showToiPlusEntryPoints: false,
  isPrime: false,
  geoCityData: {},
  location: null,
  refreshTime: 0,
  isCityHP: false,
  isPaginationEnabled: false,
  BudgetoMeterData: {},
};

export default connect(mapStateToProps, mapDispatchtoProps)(NewsListing);
